import {UISidebarController} from '../../../ui_html/new_layout/UISidebarController'

export class UIDTermsSceneController {
    private readonly sidebarController: UISidebarController
    private readonly termsSceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.termsSceneContainerDiv = document.getElementById('scene_discord_terms_container') as HTMLDivElement
    }

    hide() {
        this.termsSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.termsSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
